import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
    selector: '[re-center-in-container]',
    standalone: false
})
export class CenterInContainerDirective {

  constructor(private element: ElementRef) {
    window.addEventListener("resize", this.resizeCallback);
    var el: HTMLElement = this.element.nativeElement;
    el.style.position = "absolute";

    var targetNode = el;
    var observer = new MutationObserver(() => {
      if (targetNode.style.display != 'none') {
        this.resize();
      }
    });
    observer.observe(targetNode, { attributes: true, childList: true });

  }
  ngOnDestroy(): void {
    window.removeEventListener("resize", this.resizeCallback);
  }

  private resizeCallback = _ => {
    this.resize();
  };
  private resize() {
    var el: HTMLElement = this.element.nativeElement;
    var size = el.getBoundingClientRect();
    el.style.top = (window.innerHeight / 2 - size.height / 2) + "px";
    el.style.left = (window.innerWidth / 2 - size.width / 2) + "px";

  }


  @Input("re-center-in-container")
  Use = false;
}
